import { mangaList, formatViews } from '@/mocks/manga';

const rankIds = ['m04', 'm01', 'm16', 'm06', 'm03', 'm11', 'm08', 'm02', 'm15', 'm17'];

export default function RankingSection() {
  const ranked = rankIds
    .map((id) => mangaList.find((m) => m.id === id))
    .filter((m): m is NonNullable<typeof m> => Boolean(m));

  return (
    <section id="ranking" className="mx-auto max-w-6xl px-4 py-12 md:px-6 md:py-16 lg:px-8">
      <div className="mb-6 flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <h2 className="flex items-center gap-2 font-heading text-2xl text-foreground-950">
            <i className="ri-trophy-fill text-accent-400" />
            人气榜单
          </h2>
          <p className="mt-1 text-sm text-foreground-600">根据读者人气与评分实时排行的热门作品</p>
        </div>
        <span className="text-xs text-foreground-500">每日 08:00 更新</span>
      </div>

      <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
        {ranked.map((m, i) => (
          <a
            key={m.id}
            href="#reading"
            className="group flex items-center gap-4 rounded-lg bg-background-100 p-3 ring-1 ring-background-200/70 transition hover:ring-accent-400/40"
          >
            <span
              className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-md font-heading text-lg ${
                i < 3 ? 'bg-accent-500 text-background-50' : 'bg-background-200 text-foreground-700'
              }`}
            >
              {i + 1}
            </span>
            <div className="relative h-16 w-11 shrink-0 overflow-hidden rounded-md">
              <img
                src={m.cover}
                alt={`${m.title} 人气榜单免费漫画封面`}
                title={`${m.title} ${m.subtitle}`}
                className="h-full w-full object-cover object-top"
              />
            </div>
            <div className="min-w-0 flex-1">
              <h3 className="truncate text-sm font-bold text-foreground-950">{m.title}</h3>
              <p className="truncate text-xs text-foreground-600">{m.subtitle}</p>
              <p className="mt-1 flex items-center gap-2 text-[11px] text-foreground-500">
                <span className="rounded-full bg-primary-500/15 px-2 py-0.5 text-[11px] text-primary-400">{m.category}</span>
                <span className="flex items-center gap-0.5">
                  <i className="ri-star-fill text-accent-400" /> {m.rating}
                </span>
                <span className="flex items-center gap-0.5">
                  <i className="ri-eye-line" /> {formatViews(m.views)}
                </span>
              </p>
            </div>
            <i className="ri-arrow-right-line shrink-0 text-foreground-500 transition group-hover:text-accent-400" />
          </a>
        ))}
      </div>
    </section>
  );
}